import { use } from 'react';
import { SoftphoneContext } from '../contexts/softphone';

export function useSoftphone() {
  return use(SoftphoneContext);
}
